import React, { Component } from "react";
import { connect } from "react-redux";
import { withAuth0 } from "@auth0/auth0-react";
import { loginWithAuth0Token } from "../../actions/auth.actions";
import { API_ROOT } from "../../utils/api-config";

class SwaggerLanding extends Component {

  async componentDidMount() {
    const { isLoggedIn, isUsingAuth0, auth0 } = this.props;

    if (isLoggedIn) {
      // User is already logged into Camvio - get token and go to Swagger
      await this.redirectToSwagger();
    } else if (isUsingAuth0 && auth0.user) {
      // User is Auth0 authenticated but not yet logged into Camvio
      await this.loginAndRedirect();
    } else if (isUsingAuth0 && !auth0.isLoading && !auth0.user) {
      // User is not authenticated at all - redirect to Auth0 login
      await auth0.loginWithRedirect({
        appState: { returnTo: "/swagger-landing" }
      });
    } else {
      // Non-Auth0 setup - redirect to regular login
      this.props.history.push("/login");
    }
  }

  /**
   * User is already logged into Camvio - just grab token from localStorage
   * and redirect to Swagger
   */
  async redirectToSwagger() {
    const currentUser = JSON.parse(localStorage.getItem("currentUser"));
    if (currentUser && currentUser.token) {
      this.openSwagger(currentUser.token);
    } else {
      // Something went wrong, force re-login
      await this.loginAndRedirect();
    }
  }

  /**
   * Exchange Auth0 token for Camvio token then redirect to Swagger
   */
  async loginAndRedirect() {
    const { auth0 } = this.props;
    try {
      const token = await auth0.getAccessTokenSilently({
        detailedResponse: true
      });

      // Exchange Auth0 token for Camvio API token
      // Reuses exact same action as MainLayout
      await this.props.loginWithAuth0Token(token, auth0.user);

      // Get the freshly stored Camvio token
      const currentUser = JSON.parse(localStorage.getItem("currentUser"));
      if (currentUser && currentUser.token) {
        this.openSwagger(currentUser.token);
      } else {
        this.setState({ error: "Failed to retrieve API token. Please try again." });
      }
    } catch (err) {
      console.error("SwaggerLanding - login error:", err);
      this.setState({ error: "Authentication failed. Please try again." });
    }
  }

  /**
   * Pre-authorize Swagger UI with Bearer token and redirect to it
   * Stores the token in Swagger UI's localStorage format so it is
   * automatically picked up when the page loads
   */
  openSwagger(token) {
    window.location.href = `${API_ROOT}/swagger-ui.html?token=${encodeURIComponent(token)}`;
  }
  // openSwagger(token) {
  //   const swaggerAuth = {
  //     "api-token": {
  //       name: "api-token",
  //       schema: { type: "apiKey", in: "header", name: "Authorization" },
  //       value: token
  //     }
  //   };
  //   localStorage.setItem("authorized", JSON.stringify(swaggerAuth));
  //
  //   window.location.href = `${API_ROOT}/swagger-ui.html`;
  // }

  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  render() {
    const { error } = this.state;
    return (
      <div style={styles.container}>
        <div style={styles.box}>
          <h2 style={styles.title}>Camvio API</h2>
          {error ? (
            <>
              <p style={styles.error}>{error}</p>
              <button
                style={styles.button}
                onClick={() => this.props.history.push("/login")}>
                Back to Login
              </button>
            </>
          ) : (
            <p style={styles.message}>
              Opening API documentation...
            </p>
          )}
        </div>
      </div>
    );
  }
}

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#f5f5f5"
  },
  box: {
    background: "white",
    padding: "40px",
    borderRadius: "8px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
    width: "350px",
    textAlign: "center"
  },
  title: {
    color: "#333",
    marginBottom: "16px"
  },
  message: {
    color: "#666",
    fontSize: "14px"
  },
  error: {
    color: "red",
    fontSize: "13px",
    marginBottom: "16px"
  },
  button: {
    width: "100%",
    padding: "12px",
    backgroundColor: "#635dff",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "16px"
  }
};

const mapStateToProps = (state) => ({
  isLoggedIn: state.auth.isLoggedIn,
  isUsingAuth0: state.systemConfigs.isUsingAuth0
});

const mapDispatchToProps = {
  loginWithAuth0Token
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAuth0(SwaggerLanding));